/**
 * @ngdoc enum
 * @name mx.shell.ActionContextType
 * @module mx.shell
 *
 * @description
 * Enum for Action execution scope.
 */
export enum ActionContextType {
	/**
	 * @ngdoc property
	 * @name mx.shell.ActionContextType#None
	 *
	 * @description
	 * Action is available regardless any business object is selected
	 */
	None = 0,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionContextType#Single
	 *
	 * @description
	 * Action is available when only one business object is selected
	 */
	Single = 1,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionContextType#Multiple
	 *
	 * @description
	 * Action is available when one or more business objects are selected
	 */
	Multiple = 2,
}
